import React, { useEffect } from "react";
import Header from "../../common/Header/index";
import NewFooter from "../../common/NewFooter";
import BDLogo from '../../assets/home/bacchus-drinks-logo.svg';
import { useTranslation } from "react-i18next";
import { 
    Background, 
    QuestionTittle,
    QuestionWrapper,
    QuestionP,
    AnswerP
} from "../../common/Faq/styles";
import { 
    PrivacyPolicyLogo
} from "./styles";

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    useEffect(() => {
        document.getElementById('privacy-policy').scrollIntoView(); 
    }, []);

    return(
        <>
            <Header/>
            <Background id="privacy-policy">
                <PrivacyPolicyLogo src={BDLogo} />
                <QuestionTittle>{t("privacyPolicy")}</QuestionTittle>
                <QuestionWrapper>
                    <AnswerP>{t("privacyPolicyHas")}</AnswerP>
                    <QuestionP>{t("whatPersonalInformation")}</QuestionP>
                    <AnswerP>{t("whenOrdering")}</AnswerP>
                    <QuestionP>{t("whenCollect")}</QuestionP>
                    <AnswerP>{t("collectInformation")}</AnswerP>
                    <QuestionP>{t("howDoWeUse")}</QuestionP>
                    <AnswerP>{t("weMayUse")}</AnswerP>
                    <AnswerP>{t("toFollowUp")}</AnswerP>
                    <AnswerP>{t("howDoWeProtectSt")}<br />{t("howDoWeProtectNd")}</AnswerP>
                    <AnswerP>{t("weUseRegular")}</AnswerP>
                    <AnswerP>{t("yourPersonalInformation")}</AnswerP>
                    <AnswerP>{t("weImplement")}</AnswerP>
                    <AnswerP>{t("allTransactions")}</AnswerP>
                    <QuestionP>{t("doWeUseCookies")}</QuestionP>
                    <AnswerP>{t("cookiesAreSmall")}</AnswerP>
                    <QuestionP>{t("useCookies")}</QuestionP>
                    <AnswerP>{t("compileAggregateSt")}<br />{t("compileAggregateNd")}<br />{t("compileAggregateRd")}</AnswerP>
                    <QuestionP>{t("thirdParty")}</QuestionP>
                    <AnswerP>{t("weDoNotSell")}</AnswerP>
                    <QuestionP>{t("thirdPartyLinks")}</QuestionP>
                    <AnswerP>{t("notInclude")}</AnswerP>
                    <QuestionP>{t("google")}</QuestionP>
                    <AnswerP>{t("googleAdvertising")}<a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">link</a>. {t("notEnabledGoogle")}</AnswerP>
                    <QuestionP>{t("coppa")}</QuestionP>
                    <AnswerP>{t("whenItComes")}<br />{t("weDoNotSpecifically")}</AnswerP>
                    <AnswerP>{t("doWeLetThird")}</AnswerP>
                </QuestionWrapper>
            </Background>
            <NewFooter/>
        </>
    )
}
export default PrivacyPolicy;
